export default __webpack_public_path__ + "static/media/city.30ad5ae2.png";